import { IconSvgObject } from "types/common/icons";
import { VerifiedItem } from "../../types/verified";
import { ReverifyRequestedActivity } from "shared/app/ActivityLog/types";
import { ReverifyRequest } from "shared/types";

export enum ReverifyTabType {
  InitialVerification = "initial", // FE-only
  DocumentsUpload = "documents_reverification",
  ApplicantRequest = "applicant_request",
  Failed = "failed" // FE-only
}

export interface EmptyReverifyItem {
  reverifyRequest?: ReverifyRequest | null;
  is_archived: boolean;
  reverify_log?: ReverifyRequestedActivity;
}
export interface ProcessingReverifyContent {
  title: string;
  subtitle?: string;
  description: string;
  showDate: boolean;
  showCancelButton: boolean;
  icon: IconSvgObject;
  iconClassName?: string;
  iconWrapperClassName?: string;
}

export interface ReverifyFormattedDetails {
  initiatedBy: string;
  formattedDate: string;
  incomeName: string;
}

export type ReverifyDetails = {
  reverifyType: ReverifyTabType;
} & ReverifyFormattedDetails &
  ProcessingReverifyContent;

export type ReverifyAttempt = EmptyReverifyItem | VerifiedItem | VerifiedItem[];
